import _ from 'underscore';
import { FilterBar } from '@bingads-webui/filter-bar';
import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import { BaseFilterAgent } from './base-filter-agent';

class DeterministicFilterBar extends DeterministicWrapperView {
  viewFactory(options) {
    return new FilterBar(options);
  }
}

/**
 * Manage the creation/removal and show/hide of FilterBar view<br>
 * Call FilterService to change filter state
 * @extends BaseFilterAgent
 * @fires FilterBarAgent#filter-bar-removed
 * @fires FilterBarAgent#filter-bar-edited
 */
export class FilterBarAgent extends BaseFilterAgent {
  /**
   * Create filter bar view and append to container passed in by consumer<br>
   * Or update existing filter bar view with new filter entity and show
   * @param {Object} filter - FilterEntity
   * @returns {undefined}
   */
  create(filter) {
    const extendedFilter = _.extend(filter, {
      options: {
        shortDateFormat: this.options.shortDateFormat,
      },
    });

    const options = _.extend(
      {},
      this.options.filterbar,
      {
        filter: extendedFilter,
        schemaI18n: this.options.schemaI18n,
      }
    );

    this.deterministicView = new DeterministicFilterBar({
      options,
      i18n: this.options.i18n,
    });

    this.listenTo(this.deterministicView, 'removed', () => {
      this.deterministicView = null;
    });
    this.listenTo(this.deterministicView, 'remove', this.remove);
    this.listenTo(this.deterministicView, 'edit', () => this.trigger('filter-bar-edited'));

    return this.deterministicView;
  }

  update(filter) {
    const extendedFilter = _.extend(filter, {
      options: {
        shortDateFormat: this.options.shortDateFormat,
      },
    });
    this.deterministicView.view.changeFilter(extendedFilter);
  }

  /**
   * Remove FilterBar view and reset filter state by removing
   * current applied filter
   * @private
   * @fires FilterBarAgent#filter-bar-removed
   * @returns {undefined}
   */
  remove() {
    this.options.filterService.removeEditableFilter();
    this.trigger('filter-bar-removed');
  }
}
